"use client";
import React, { useState } from 'react';
import Image from 'next/image';

interface ImageWithFallbackProps extends React.ComponentProps<typeof Image> {
  src: string; // Required original image source
  fallbackSrc: string; // Fallback source for the image
}

const ImageWithFallback: React.FC<ImageWithFallbackProps> = ({ src, fallbackSrc, alt, ...props }) => {
  const [imgSrc, setImgSrc] = useState<string>(src);

  return (
    <Image
      {...props}
      src={imgSrc}
      alt={alt}
      onError={() => setImgSrc(fallbackSrc)} // Switch to fallbackSrc on error
      loading="lazy" // Default lazy loading
    />
  );
};

export { ImageWithFallback };
